import * as React from 'react';

interface ItemsCountProps {
  items: Array<any>;
}

export const ItemsCount: React.FC<ItemsCountProps> = ({ items }) => {
  const count = items?.length || 0;
  const text = count === 1 ? 'Selection' : 'Selections';

  return (
    <span>
      {count} {text}
    </span>
  );
};
